<template>
  <div class="supplier">
    <!-- 面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>进口商管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 内容 -->
    <el-card class="main">
      <!-- 头部查询 -->
      <div slot="header" class="clearfix">
        <el-input placeholder="请输入内容" v-model="inputVal" clearable></el-input>
        <el-button
         
          type="primary"
          size="small"
          @click="queryOrder"
        >查询</el-button>
        <el-button type="primary" @click="addSup">添加进口商</el-button>
      </div>
      <!-- 表格 -->
      <!-- 信息列表 -->
      <el-table :data="manageData" style="width: 100%">
        <el-table-column label="进口商名称" prop="name"></el-table-column>
        <el-table-column label="国家" prop="country"></el-table-column>
        <el-table-column label="EORI" prop="eori"></el-table-column>
        <el-table-column label="VAT" prop="vat"></el-table-column>
        <el-table-column label="地址" prop="address" width="350"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.$index,scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <div class="block" style="margin-top:20px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 40,60, 80,100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
      <!-- 弹出框 -->
      <!-- 弹出框 -->
      <el-dialog :title="price ? '新增进口商' : '修改进口商'" :visible.sync="dialogFormVisible" :before-close="closeDialog" :close-on-click-modal="false">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="进口商" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入进口商"></el-input>
          </el-form-item>
          <el-form-item label="国家" prop="country">
            <!-- 国家组件 -->
            <country :countrys="ruleForm.country" @getCty="getCountry"></country>
          </el-form-item>
          <el-form-item label="EORI" prop="eori">
            <el-input v-model="ruleForm.eori" placeholder="请输入EORI"></el-input>
          </el-form-item>
          <el-form-item label="VAT" prop="vat">
            <el-input v-model="ruleForm.vat" placeholder="请输入VAT/BOUND/EIN"></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input type="textarea" v-model="ruleForm.address"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">{{price?"添 加":"修 改"}}</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
//引入api
import httpApi from "@/http/api";
//引入组件
import Country from "@/components/Country";
export default {
  components: {
    Country
  },
  data() {
    return {
      manageData: [], //列表数组
      options: [], //国家列表
      dialogFormVisible: false, //弹出框
      price: true, //新增修改
      index: 0, //下标
      inputVal:"",
      currentPage: 1, //分页初始页
      pagesize: 20, //分页每页数据
      total: 0, //分页总数
      ruleForm: {
        // 弹出框数据
        name: "",
        country: "",
        eori: "",
        vat:"",
        address: "",
        id: 0 //供应商id
      },
      // 正则验证
      rules: {
        name: [{ required: true, message: "请输入进口商", trigger: "blur" }],
        country: [{ required: true, message: "请选择国家", trigger: "blur" }],
        vat: [{ required: true, message: "请输入vat", trigger: "blur" }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }]
      }
    };
  },
  methods: {
    //新增供应商
    addSup() {
      this.dialogFormVisible = true;
      // 新增学生
      this.price = true;
      // 数据清理
      for (let i in this.ruleForm) {
        this.ruleForm[i] = "";
      }
    },
    closeDialog(){
      this.$refs.ruleForm.clearValidate();
      this.dialogFormVisible=false
    },
    //获取国家
    getCountry(e) {
      this.ruleForm.country = e;
    },
    //编辑
    handleEdit(index, row) {
      let that = this;
      that.dialogFormVisible = true;
      that.price = false;
      that.ruleForm = {
        name: row.name,
        country: row.country,
        eori: row.eori,
        address: row.address,
        id: row.id,
        vat:row.vat
      };
      that.index = index;
    },
    handleDelete(index, row) {
      let that = this;
      that
        .$confirm("此操作将永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          httpApi
            .updateUser( { id:row.id} )
            .then(res => {
              //判断接收的响应码
              if (res.data.code == "ok") {
                that.$message.success("删除成功!");
                // 在数组里面删除数据
                that.manageData.splice(index, 1);
              } else {
                that.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //添加供应商
    submitForm(formName) {
      let that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          //判断是修改还是新增
          if (that.price) {
            //新增
            httpApi
              .addUser({
                name: that.ruleForm.name, // 名称
                country: that.ruleForm.country, //接触人
                eori: that.ruleForm.eori, //联系方式
                address: that.ruleForm.address, //地址
                type: 0,
                vat: that.ruleForm.vat
              })
              .then(res => {
                if (res.data.code == "ok") {
                  that.ruleForm.id = 0;
                  //添加成功
                  that.$message.success("添加成功！");
                  that.dialogFormVisible = false;
                  that.manageData.unshift(
                    JSON.parse(JSON.stringify(that.ruleForm))
                  );
                  // 数据清理
                  that.$refs[formName].resetFields();
                } else {
                  that.$message.error(res.data.message);
                }
              });
          } else {
            //修改
            httpApi
              .modifyUser({
                name: that.ruleForm.name, // 名称
                country: that.ruleForm.country, //国家
                eori: that.ruleForm.eori, //税号
                address: that.ruleForm.address, //地址
                type: 0,
                id: that.ruleForm.id, //id
                vat: that.ruleForm.vat
              })
              .then(res => {
                if (res.data.code == "ok") {
                  that.$message.success("修改成功！");
                  that.dialogFormVisible = false;
                  that.manageData.splice(
                    that.index,
                    1,
                    JSON.parse(JSON.stringify(that.ruleForm))
                  );
                } else {
                  that.$message.error(res.data.message);
                }
              });
          }
        } else {
          return false;
        }
      });
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function(size) {
      this.pagesize = size;
      this.currentPage = 1;
      //每页下拉显示数据
      this.queryLists();
    },
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      //点击第几页
      this.queryLists();
    },
    queryOrder() {
      this.queryLists();
    },
    queryLists() {
      //查询供应商
      httpApi
        .queryUser({
          params: {
            page: this.currentPage,
            rows: this.pagesize,
            type: 0,
            name:this.inputVal
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            this.manageData = res.data.data.rows;
            this.total = res.data.data.total;
          } else {
            this.$message.error(res.data.message);
          }
        });
    }
  },
  created() {
    this.queryLists();
  }
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  width: 28% !important;
  .el-dialog__body {
    padding-bottom: 0px;
    /deep/.el-input,
    .el-textarea {
      float: left;
      width: 80% !important;
      .el-textarea__inner{
        height: 100px;
      }
    }
    .el-form-item__content {
      text-align: left;
      .el-select {
        position: absolute;
        width: 100%;
      }
    }
  }
  .el-dialog__footer {
    .dialog-footer {
      margin-right: 35px;
    }
  }
}
/deep/.el-form-item__label {
  font-size: 13px;
}
/deep/.block {
  margin-top: 20px;
  text-align: center;
}
</style>